// import { useEffect } from "react";
import {
  createFileRoute,
  Outlet,
  redirect,
  // useNavigate,
} from "@tanstack/react-router";
// import { useAuthStore } from "@/lib/stores/authStore";
// import { useStudyStore } from "@/lib/stores/studyStore";
// import { StudyProgressBar } from "@/components/study/StudyProgressBar";

export const Route = createFileRoute("/(content)/study")({
  // Study temporarily disabled: send any /study URL back to the app.
  // The adults route guard forwards children / new visitors to the right place.
  beforeLoad: () => {
    throw redirect({ to: "/adults/exercises" });
  },
  component: StudyRouteLayout,
});

function StudyRouteLayout() {
  // const navigate = useNavigate();
  // const user = useAuthStore((s) => s.user);
  // const fetchStatus = useStudyStore((s) => s.fetchStatus);
  // const hasFetched = useStudyStore((s) => s.hasFetched);

  // useEffect(() => {
  //   if (!user) return;
  //   if (user.audience === "CHILD") {
  //     navigate({ to: "/children/exercises" });
  //     return;
  //   }
  //   if (user.audience === "ADULT" && !hasFetched) {
  //     fetchStatus();
  //   }
  // }, [user, hasFetched, fetchStatus, navigate]);

  return (
    <>
      {/* <StudyProgressBar /> */}
      <Outlet />
    </>
  );
}
